import classNames from 'classnames';
import Modal from 'rsuite/lib/Modal';
import { ButtonPrimary, FileUpload } from '../../../../../components';
import { ArquiteturaPrecosUploadModalProps } from '../../types';
import styles from './ArquiteturaPrecosUploadModal.module.scss';

export const ArquiteturaPrecosUploadModal = ({
  className,
  file,
  errorMessage,
  onFileChange,
  onInvalidFile,
  onDownloadTemplate,
  onSubmit,
  onHide,
  show,
  ...props
}: ArquiteturaPrecosUploadModalProps) => (
  <Modal className={classNames('info-modal', styles.modal, className)} onHide={onHide} show={show} {...props}>
    <form onSubmit={event => event.preventDefault()}>
      <Modal.Header>
        <div className={styles.header}>
          <Modal.Title className={styles.title}>Novo envio de arquitetura</Modal.Title>
          <p>Ao enviar, vamos validar o arquivo e atualizar a arquitetura de preços.</p>
        </div>
      </Modal.Header>

      <Modal.Body className={styles.body}>
        <FileUpload
          value={file}
          onChange={onFileChange}
          onInvalidFile={onInvalidFile}
          errorMessage={errorMessage}
          title="Novo envio de arquitetura"
          templateLabel="Baixe aqui o modelo de arquivo"
          onTemplateClick={onDownloadTemplate}
          description={
            <p>
              Aceitamos arquivos .xlsx, .xls e .csv. <br /> Arraste e solte aqui ou clique para selecionar.
            </p>
          }
          inputProps={{ id: 'price-architecture-file' }}
        />
      </Modal.Body>

      <Modal.Footer>
        <ButtonPrimary skin="blue" theme="ghost" type="button" onClick={onHide}>
          CANCELAR
        </ButtonPrimary>
        <ButtonPrimary skin="blue" theme="filled" type="submit" disabled={!file || Boolean(errorMessage)} onClick={onSubmit}>
          ENVIAR ARQUIVO
        </ButtonPrimary>
      </Modal.Footer>
    </form>
  </Modal>
);
